export const CONTACT_US_THANK_YOU_URL = '/contact-us/thank-you';
export const PAGE_TITLE = 'Thank You For Contacting Us';